import React from 'react';
import Foo from './CageDetailsTables/Foo';
import SupplierCaps from './CageDetailsTables/SupplierCaps';
import ContractHistory from './CageDetailsTables/contractHistory';
import ItemDetails from './niinDetailTables/ItemDetails';
import RecentSolicitations from './niinDetailTables/RecentSolicitations';
import ToolingRecords from './niinDetailTables/ToolingRecords';
import StockOnHand from './niinDetailTables/StockOnHand';
import ToolingCommentsGov from './niinDetailTables/ToolingCommentsGov';
import DrawingDetails from './niinDetailTables/DrawingDetails';
import WSDC from './niinDetailTables/WSDC';
import niinContractHistory from './niinDetailTables/niinContractHistory';
import PNDetails from './niinDetailTables/PNDetails';
import TechCharacteristics from './niinDetailTables/TechCharacteristics';
import ItemDescription from './niinDetailTables/ItemDescription';
import PackagingInfo from './niinDetailTables/pkgInfo';
import ToolingSearch from './historyTables/ToolingSearch';
import ProcurementSearch from './historyTables/ProcurementSearch';

const Components = {
  procurementSearch: ProcurementSearch,
  toolingSearch: ToolingSearch,
  supplierCaps: SupplierCaps,
  organization: Foo,
  contractHistory: ContractHistory,
  itemDetails: ItemDetails,
  recentSolicitations: RecentSolicitations,
  toolingRecords: ToolingRecords,
  stockOnHand: StockOnHand,
  toolingCommentsGov: ToolingCommentsGov,
  niinContractHistory,
  drawingDetails: DrawingDetails,
  WSDC,
  pnDetails: PNDetails,
  techCharacteristics: TechCharacteristics,
  itemDescription: ItemDescription,
  packagingInfo: PackagingInfo,
};

export default (block, auth, addToolinCommentGov) => {
  if (typeof Components[block[0]] !== 'undefined') {
    if (block[1].length > 0 || block[0] === "toolingCommentsGov") {
      return (
        React.createElement(
          Components[block[0]], { block: block[1], auth, addToolinCommentGov },
          React.createElement('div', { id: `${block[0]}` }),
        )
      );
    }
    return React.createElement(() => <div />);
  }

  return React.createElement(
    () => <div>The component {block[0]} has not been created yet.</div>,
    { key: block._uid },
  );

};



// WEBPACK FOOTER //
// ./src/pages/universalDetails/TableBuilder.jsx